import styled from "styled-components";
import menu from "../../assets/menu-burger-icon.svg";

const MenuContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px;

  
`;

const BurgerMenu = ({onclick, myref}) => {
  
  return (
    <>
      <MenuContainer onClick={onclick} ref={myref}>
        <img src={menu} alt="menu icon" />
      </MenuContainer>
    </>
  );
};

export default BurgerMenu;
